import apiClient from '../../core/apiClient';

export const drService = {
  getDRStatus: async () => {
    const response = await apiClient.get('/api/admin/risk/dashboard');
    return response.data.dr_status;
  },
  toggleFinancialFreeze: async (isFrozen: boolean, reason: string) => {
    const response = await apiClient.post('/api/superadmin/dr/freeze-toggle', { 
      is_frozen: isFrozen,
      reason 
    });
    return response.data;
  },
  triggerFailover: async (reason: string) => {
    const response = await apiClient.post('/api/superadmin/dr/failover', { reason });
    return response.data;
  }
};
